import { combineReducers } from '@reduxjs/toolkit';
import AppInitialState from './AppInitialState';
import { SigninReducer } from './Login/Reducers';
import { GlobalLoadingReducer } from './GlobalLoading/Reducers';
import { UiReducer } from './Ui/Reducers';
import { AuthenticationModalReducer } from './AuthenticationModal/Reducers';

import { Types as SigninTypes } from './Login/Actions';

const appReducer = combineReducers({
  //auth && miscellaneous
  signin: SigninReducer,

  //ui and gui
  globalLoading:GlobalLoadingReducer,
  ui:UiReducer,
  authenticationModal:AuthenticationModalReducer,

});

const rootReducer = (state: any, action: any) => {
  if (action.type === SigninTypes.LOGOUT) {
    state = AppInitialState
  }
  return (appReducer(state, action))
}

export type RootState = ReturnType<typeof appReducer>
export default rootReducer;